import React from 'react';
import { Wallet } from 'lucide-react';
import { TabPayments } from './Reports';

// Standalone page for the payments-received report (sidebar under Reports).
export default function PaymentsReport() {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <Wallet size={22} className="text-orange-500" />
        <div>
          <h1 className="text-xl font-bold text-gray-800">Payments Received</h1>
          <p className="text-xs text-gray-400">Money in over a period, split by card / cash / EFT</p>
        </div>
      </div>
      <TabPayments />
    </div>
  );
}
